/**
 * Created by desheng.zhao on 2018/11/30.
 */
import * as date from './date'
import * as filters from './filters'
import tel from './tel'
import b2g from './BtoG'

// 全局过滤器
export const global = {
  ...date,
  ...filters,
  tel,
  b2g
}

// 局部过滤器
export const local = {
  ...date,
  ...filters
}



// WEBPACK FOOTER //
// ./src/filters/index.js